export const AUTH_AUTHORIZE_ENDPOINT = '/authorize';
export const AUTH_LOGOUT_ENDPOINT = '/logout';
export const AUTH_REFRESH_ENDPOINT = '/refresh';
export const AUTH_USER_INFO_ENDPOINT = '/user_info';
